import React from 'react'

import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'

import {AllFiltersBottomSheet} from './AllFiltersBottomSheet'
import {AllFiltersPopover} from './AllFiltersPopover'

export const AllFilters = () => {
  const {isMobile} = useDeviceLayout()

  if (isMobile) return <AllFiltersBottomSheet />
  return <AllFiltersPopover />
}
